export const clearLocalStorageExcept = (names: string[] = []) => {
  const keys = Object.keys(localStorage);
  for (let index = 0; index < keys.length; index++) {
    const key = keys[index];

    console.log(key, names);
    if (!names.includes(key)) {
      localStorage.removeItem(key);
    }
  }
}